export default __webpack_public_path__ + "static/media/README.f023ee26.md";